// extracted by mini-css-extract-plugin
export default {"wrapper":"grid-toggle_wrapper__Q3VP4","faded":"grid-toggle_faded__XpgO5"};